import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
	new Swiper('.swiper.reviews', {
		modules: [Navigation],
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 48,
		speed: 400,
		grabCursor: true,
		createElements: true,

		navigation: true,

		breakpoints: {
			1200: {
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
		},
	});
});
